import { FormInstance } from 'antd'
import { transformData, useProfile } from 'hooks'
import { IOptionItem } from 'interfaces'
import { useEffect, useState } from 'react'
import { useClinicServices } from 'services'

const useMajorServiceSelect = (
  form: FormInstance<any>,
  onSearch?: () => void,
  majorId?: number,
  serviceId?: number
) => {
  const { transformArrayObject } = transformData()
  const { getClinicServices } = useClinicServices()
  const [optionsMajor, setOptionsMajor] = useState<any>([])
  const [optionsService, setOptionsService] = useState<any>([])
  const { profile, userId } = useProfile()

  useEffect(() => {
    if (profile?.clinic_majors) {
      const majors = transformArrayObject(profile?.clinic_majors || [], {
        value: 'id',
        label: 'name'
      })
      setOptionsMajor(majors)
      const findMajor = majors?.find(
        (item: IOptionItem) => item?.value === majorId
      )
      if (findMajor) {
        handleGetServices(findMajor?.value, serviceId, true)
      }
    } else {
      setOptionsService([])
    }
  }, [profile?.clinic_majors])

  const handleOnChangeMajor = (majorId: number) => {
    if (majorId) {
      handleGetServices(majorId, undefined, true)
    } else {
      setOptionsService([])
      handleOnSearch()
    }
  }

  const handleGetServices = (
    majorId: number,
    serviceId?: number,
    isSearch?: boolean
  ) => {
    let services: any = []
    const query = {
      clinic_id: userId,
      major_id: majorId
    }
    getClinicServices(majorId ? { query } : undefined).then((res) => {
      if (res._successfully) {
        services = transformArrayObject(res.data, {
          value: 'id',
          label: 'name'
        })
        setOptionsService(services)

        const findService = services?.find(
          (item: IOptionItem) => item.value === serviceId
        )
        form.setFieldValue('service_id', findService?.value)
        form.setFieldValue('major_id', majorId)
        if (isSearch) handleOnSearch()
      }
    })
  }

  const handleOnSearch = () => {
    if (onSearch) onSearch()
  }

  return {
    optionsMajor,
    optionsService,
    handleOnChangeMajor
  }
}

export default useMajorServiceSelect
